import * as React from 'react';

function createChildIsTypeOf(type) {
  return function childIsTypeOf(child) {
    return child && child.type === type;
  };
}
function useMergedRefs(...refs) {
  return React.useMemo(() => {
    const filteredRefs = refs.filter((ref) => ref !== null && ref !== void 0);
    if (filteredRefs.length === 0) {
      return null;
    }
    return function refCallback(node) {
      filteredRefs.forEach((ref) => {
        if (typeof ref === "function") {
          ref(node);
          return;
        } else if (typeof ref === "object") {
          try {
            ref.current = node;
          } catch (error) {
            throw new Error(`Unable to assign ref: ${ref}, node: ${node}`);
          }
        }
      });
    };
  }, [refs]);
}
function getValidChildren(children) {
  return React.Children.toArray(children).filter((child) => React.isValidElement(child));
}

export { createChildIsTypeOf, getValidChildren, useMergedRefs };
